export default __webpack_public_path__ + "proximanova-lightit-webfont.woff2";